<script setup>
import {useSystem} from "../../store/system";
import router from "../../router";
import {onActivated, onMounted} from "vue";

const systemStore = useSystem()

onActivated(() => {
  document.title = 'Partner with HexMiner | Earn Commissions on Crypto Mining';
  document.querySelector('meta[name="description"]').setAttribute('content', 'Join HexMiner’s affiliate program. Earn Bitcoin daily by\n' +
      'promoting top cloud mining services. High commissions & rewards');
})
</script>

<template>
  <div>
    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
            <div class="section__title">
              <h1>{{systemStore.getFrontModuleContent(16).title}}</h1>
              <p>{{systemStore.getFrontModuleContent(16).sub_title}}</p>
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- contest -->
    <div class="section">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12 col-lg-7 col-xl-8">
            <!-- invest -->
            <div class="invest invest--contest">
              <h2 class="invest__title">{{systemStore.getFrontModuleContent(16, 1)?.title}}</h2>
              <p class="invest__text">{{systemStore.getFrontModuleContent(16, 1)?.sub_title}}</p>

              <div class="progressbar progressbar--contest">
                <h3 class="progressbar__title">Contestants:</h3>
                <div class="progress" role="progressbar" aria-label="Animated striped" :aria-valuenow="systemStore.getFrontModuleContent(16, 1)?.description" aria-valuemin="0" aria-valuemax="100"><div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 75%"><span>{{systemStore.getFrontModuleContent(16, 1)?.description}}</span></div></div>
                <div class="progressbar__values">
                  <span class="progressbar__value progressbar__value--left">0</span>
                  <span class="progressbar__value progressbar__value--right">100</span>
                </div>
              </div>

              <!-- design elements -->
              <span class="block-icon block-icon--red">
							<i class="ti ti-mood-dollar"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
            <!-- end invest -->
          </div>

          <div class="col-12 col-lg-5 col-xl-4">
            <!-- node -->
            <div class="node node--contest">
              <h3 class="node__title node__title--purple">{{systemStore.getFrontModuleContent(16, 2)?.title}}</h3>
              <span class="node__date">{{systemStore.getFrontModuleContent(16, 2)?.sub_title}}</span>
              <span class="node__price" v-if="systemStore.getFrontModuleContent(16, 2)?.description"><b>{{systemStore.getFrontModuleContent(16, 2)?.description}}</b></span>
              <span class="node__line"><img src="img/dodgers/dots--line-purple.svg" alt=""></span>

              <ul class="node__list" v-for="(item, index) in systemStore.getFrontModuleContent(16, 2)?.json_data" :key="index">
                <li><i class="ti ti-circle-check"></i><b>{{item.title}}</b> {{item.desc}}</li>
              </ul>

              <button class="node__btn" type="button" @click="router.push({path: '/Signin'})">Take part</button>

              <!-- design elements -->
              <span class="stats__dodger stats__dodger--left stats__dodger--purple"></span>
              <span class="stats__dodger stats__dodger--right stats__dodger--purple"></span>
              <span class="screw screw--br"></span>
              <span class="screw screw--bl"></span>
            </div>
            <!-- end node -->
          </div>

          <!-- animation background -->
          <div class="section__canvas section__canvas--page section__canvas--first" id="canvas"></div>
        </div>
      </div>
    </div>
    <!-- end contest -->


    <section class="section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="roadmap tw-mt-4 tw-rounded-md card-bg-active !tw-justify-between" style="align-items: normal !important;">
              <el-row class="w-full">
                <el-col :span="24" :md="18">
                  <div class="tw-text-[2rem] tw-font-bold">{{systemStore.getFrontModuleContent(25).title}}</div>
                  <div>{{systemStore.getFrontModuleContent(25).sub_title}}</div>
                </el-col>
                <el-col :span="24" :md="6" class="tw-content-center">
                  <button class="section__btn xs:tw-justify-self-center sm:tw-justify-self-end xs:tw-mt-5 md:tw-mt-0" type="button" @click="router.push({path:'/Dashboard'})">{{systemStore.getFrontModuleContent(25).description}}</button>
                </el-col>
              </el-row>

              <!-- design elements -->
              <span class="block-icon block-icon--purple">
							  <i class="ti ti-topology-star-ring"></i>
						  </span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>

</style>
